export default "__VITE_ASSET__z7x34uhX__"